import ModelUtil from '@leverege/model-util';
import { DateTimeRangePicker } from '@leverege/ui-elements';
const TYPE = 'rsrc.FilterModel';
function create() {
  return {
    type: TYPE,
    filters: {
      createdAt: 'last24Hours'
    }
  };
}
const base = {
  ...ModelUtil.createAllMap('filters', 'Filter', 'Filters')
};
function getFilters(model) {
  const createdAt = base.getFilter(model, 'createdAt') || 'last24Hours';
  return {
    ...base.getFilters(model),
    createdAt
  };
}
function getFilter(model, key) {
  const f = getFilters(model);
  return f?.[key];
}
function toRsrcFilter(model) {
  const filters = getFilters(model);

  // Rsrc's have no real filtering right now
  const path = filters?.path;
  const toReturn = {
    type: 'ExpressionField.logical',
    operator: 'and',
    conditions: [],
    path
  };
  if (filters?.expression) {
    toReturn.conditions.push({
      type: 'ExpressionField.expression',
      value: filters.expression
    });
  }
  if (filters?.createdAt) {
    const range = DateTimeRangePicker.getRange(filters.createdAt);
    if (range?.start && range.end) {
      toReturn.conditions.push({
        type: 'ExpressionField.comparator',
        left: {
          type: 'ExpressionField.basic',
          value: 'createdAt'
        },
        right: range.start instanceof Date ? range.start.toISOString() : range.start,
        comparator: '>='
      }, {
        type: 'ExpressionField.comparator',
        left: {
          type: 'ExpressionField.basic',
          value: 'createdAt'
        },
        right: range.end instanceof Date ? range.end.toISOString() : range.end,
        comparator: '<='
      });
    }
  }
  return toReturn.conditions.length > 0 ? toReturn : {
    path
  };
}
export default {
  TYPE,
  create,
  ...base,
  getFilters,
  getFilter,
  toRsrcFilter
};